module.exports = __webpack_public_path__ + "701a6a22bcb1ff49086be00356ab57f0.png";